import React, { useCallback, useEffect, useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { WalletFundingPanel } from "@/components/WalletFundingPanel";
import { HelpTip } from "@/components/HelpTip";
import { Wallet as WalletIcon, RefreshCw, History } from "lucide-react";

export default function Wallet() {
  const [data, setData] = useState({ balance: 0 });
  const [ready, setReady] = useState(false);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    setError("");
    try { const { data } = await api.get("/wallet"); setData(data); setReady(true); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail)); }
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4" data-testid="wallet-page">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Gestione</p>
          <h1 className="font-head text-3xl font-bold tracking-tight mt-1">Wallet / Plafond servizi</h1>
        </div>
        <HelpTip cat="wallet" />
      </div>

      <div className="grid lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] gap-4 items-start">
      <div className="space-y-4">
      <Card className="p-5 glow-border flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 text-muted-foreground text-sm"><WalletIcon className="w-4 h-4" /> Plafond servizi disponibile</div>
          <p className="font-head text-4xl font-bold mt-1" data-testid="wallet-balance">{error ? "Non disponibile" : ready ? euro(data.balance) : "…"}</p>
          {error && <p className="text-sm text-destructive" role="alert" data-testid="wallet-load-error">{error}</p>}
        </div>
        <div className="flex items-center gap-2">
          {ready && data.low_balance && <span className="rounded-full border border-amber-500/60 bg-amber-500/10 px-3 py-1 text-xs text-amber-500" data-testid="wallet-low-alert">Plafond basso: ricaricalo per continuare a vendere</span>}
          <Button variant="ghost" size="icon" onClick={load} aria-label="Aggiorna saldo" data-testid="wallet-refresh"><RefreshCw className="w-4 h-4" /></Button>
        </div>
      </Card>

      <div className="flex flex-wrap gap-2">
        <Button asChild variant="outline" data-testid="wallet-open-history"><Link to="/app/storico-wallet"><History className="w-4 h-4 mr-2" />Storico transazioni e ricariche</Link></Button>
        <Button asChild variant="ghost" data-testid="wallet-open-auto"><Link to="/app/storico-wallet?tab=auto">Carta, IBAN e ricarica automatica</Link></Button>
      </div>
      </div>

      <WalletFundingPanel onBalanceChange={load} view="topup" />
      </div>
    </div>
  );
}
